<template>
  <div 
    class="base-card" 
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseCard",
};
</script>

<style lang="scss">
@import "./base-card.scss";
</style>
